export class HttpError {
    public status: number;
    constructor(public url: string, public error: any) {}
}
